export interface ITag {
    text: string;
    tagType: TagType;
    value: any;
}

export enum TagType {
    Person = "Person",
    Skill = "Skill",
    Account = "Account",
    AccountCluster = "AccountCluster",
    Tribe = "Tribe",
    Hive = "Hive",
    Profile = "Profile",
    Seniority = "Seniority",
    ConsultantType = "ConsultantType",
    PeopleCoach = "PeopleCoach",
    QuickFilter = "QuickFilter",
    StartDateFrom = "StartDateFrom",
    StartDateTo = "StartDateTo"
}
